import { request } from "../../Services/Api"

export const getCreditAutomationQueue = (params) =>
  request.api.get(`/admin_panel/credit-automation/`, params)

// CHA1-3066: real, deployed on dev-5 - {status, failure_reason?, failure_details?}
export const updateCreditAutomationStatus = ({ id, ...data }) =>
  request.api.patch(`/admin_panel/credit-automation/${id}/update-status/`, data)

// Reason options for the "Action needed" dropdown in ChangeStatusModal.
export const getCreditAutomationStatusOptions = () =>
  request.api.get(`/admin_panel/credit-automation/status_options/`)

// CHA1-3068: persist an admin comment on a credit-automation row (shared across Admins).
export const addCreditAutomationComment = ({ id, comment }) =>
  request.api.patch(`/admin_panel/credit-automation/${id}/comment/`, { comment })

export const exportCreditAutomation = (params) =>
  request.api.get(`/admin_panel/credit-automation/export/`, params)
